import z from 'zod';

export const tradeTagDbSchema = z.object({
  label: z.string().min(1),
  description: z.string().optional(),
});

export type TradeTagDb = z.infer<typeof tradeTagDbSchema>;
